import { useEffect } from "react";
import _ from 'lodash-es';
import Evisit from "../../../libs/Evisit";
import { Col, Row, Spin } from 'antd';

const createWalkin = async ({data, visit, componentData}) => {
    const ENDPOINT_MAPPING = {
        [window.CONST.VISIT.TYPE.WALKIN] : "add_walkin",
        [window.CONST.VISIT.TYPE.ECONSULT] : "add_econsult"
    }
    const visit_type = _.get(componentData, "type");
    
    var params = visit ? {
        intakeId: _.get(visit, "intake_id"),
        roomId: _.get(visit, "room_id"),
        room_code: _.get(visit, "intake.room_code"),
        provider_id: _.get(visit, "provider_id"),
        to_notify: true
    } : {
        intake_id: _.get(data, "intake.value.id"),
        room_code: _.get(data, "room.value.code"),
        invite_id: "",
        to_notify: true
    };

    if (window.user.type === window.CONST.USER.TYPE.PROVIDER &&
        _.get(data, "search_for_patient.value.code")) {
        // This is remote medic flow
        params["representative_id"] = window.user.id;
        params["user_code"] = _.get(data, "search_for_patient.value.code");
    }
    // support component.data has additional params, {type: xx, visitSubType: xx}
    const body = JSON.stringify({...componentData, ...params});

    var res = await fetch(`${window.base_url}/api_v3/visits/${ENDPOINT_MAPPING[visit_type]}`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
            'Content-Type': 'application/json',
            'X-ApiToken': window.user.token,
            'X-AccountCode': window.CONFIG.Account.code
        },
        body: body
    });
    res = await res.json();
    if (res["data"]) {
        res = res["data"];
    }
    return res;
}

const createAppt = async (data) => {
    var apptData = _.get(data, "calendar_picker.value");
    var roomData = _.get(data, "room.value");
    var intakeId = _.get(data, "intake.value.id");
    apptData = {
        ...apptData,
        member_id: window.user.id,
        type: window.CONST.VISIT.TYPE.SCHEDULED,
        cloneIntake: 0,
        room_id: roomData.id,
        room_code: roomData.code
    };
    if (intakeId) {
        apptData["intake_id"] = intakeId;
    }
    var visitSubType = _.get(window.CONFIG, "Account.visit_options.visit_type.default_subtype");
    if (visitSubType) {
        apptData["visitSubType"] = visitSubType;
    }
    var res = await fetch(`${window.base_url}/api_v3/visits/add`, {
        method: 'POST',
        credentials: 'omit',
        headers: {
            'Content-Type': 'application/json',
            'X-ApiToken': window.user.token,
            'X-AccountCode': window.CONFIG.Account.code
        },
        body: JSON.stringify(apptData)
    });
    res = await res.json();
    if (res["data"]) {
        res = res["data"];
    }
    return res;
}

const submitData = async (component, data) => {
    const visit = _.get(data, "visit.value");
    const componentData = _.get(component, "data", {});
    let res = null;
    switch (componentData.type) {
        case window.CONST.VISIT.TYPE.WALKIN:
        case window.CONST.VISIT.TYPE.ECONSULT:
            res = await createWalkin({
                data,
                visit,
                componentData
            });
            break;
        case window.CONST.VISIT.TYPE.SCHEDULED:
            res = await createAppt(data);
            break;
        default:
            res = Evisit.executeActions("submit", component, {data: componentData}, data)
            break;
    }
    _.set(data, "visit.value", res);

    return res;
}

const SetupSession = ({currentComponent, onNext, data}) => {

    useEffect(() => {
        if (currentComponent && data) {
            submitData(currentComponent, data).then(response => {
                Evisit.postMessageBackToParent({
                    name: "visit.created",
                    data: _.get(response, "data")
                });
                onNext({});
            });
        }
    }, [currentComponent, data, onNext]);

    return (
        <>
            <Row>
                <Col span={24}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "40vh"
                    }}>
                        <Spin size="large" />
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default SetupSession;